import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { TrailerScheduleResponse } from './trailer-schedule-response'

export const fetchTrailerSchedule = fetchGeneralData<TrailerScheduleResponse>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/inbound_trailers/trailer_schedules`,
)
